// extracted by mini-css-extract-plugin
export default {"noResults":"no-patient-result_noResults__3TLvN","noResultsContent":"no-patient-result_noResultsContent__OelZZ","noResultsSubHeading":"no-patient-result_noResultsSubHeading__Oh7Wt"};